import axios from 'axios';
import Instance from './interceptor';
import { API } from '../constants/Constants';
import Toast from '../components/pages/utils/Toast';

export const generateOTP = async (email) => {
  try {
    const response = await axios.post(API.GENERATE_OTP, null, {
      params: {
        email,
      },
    });
    if (response) {
      Toast({ message: `${response?.data}`, variant: 'success' });
      return response;
    }
  } catch (error) {
    if (error.response) {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    } else {
      Toast({ message: `${error.message}`, variant: 'error' });
    }
  }
};

export const verifyOTP = async (email, OTP) => {
  try {
    const response = await axios.post(API.VERIFY_OTP, null, {
      params: {
        email,
        otp: OTP,
      },
    });
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const resetPassword = async (
  email,
  OTP,
  newPassword,
  confirmPassword,
) => {
  try {
    const response = await axios.post(API.RESET_PASSWORD, null, {
      params: {
        email,
        otp: OTP,
        newPassword,
        confirmPassword,
      },
    });
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response;
    }
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const changePassword = async (
  oldPassword,
  newPassword,
  confirmNewPassword,
) => {
  try {
    const response = await Instance.put(API.CHANGE_PASSWORD, null, {
      params: {
        oldPassword,
        newPassword,
        confirmNewPassword,
      },
    });
    Toast({ message: `${response?.data?.message}`, variant: 'success' });
    return response;
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};
